import React from "react";
import { useSelector } from "react-redux";

import { useFormNavigation } from "../../components/FormNavigation/FormNavigationProvider";
import { useLayoutParams } from "../FormLayout";
import { formStepper, OtpChannel } from "../../constants";
import { FormConfirm } from "./components/FormConfirm";
import {
  getApplicantInfo,
  getIsMobileChanged,
  getIsMultiPartnerJourney,
  getIsSignatoryPrimaryMobileNoChanged,
  getSignatories
} from "../../store/selectors/appConfig";
import { useViewId } from "../../utils/useViewId";
import {
  checkIsSelectedStakeholderSignatory,
  getSelectedStakeholder
} from "../../store/selectors/stakeholders";
import { getsIsContactAndSignatoryDetailsChanged } from "../../store/selectors/sendProspectToAPI";
import { FormConfirmCompanyAndSignatory } from "./components/FormConfirmCompanyAndSignatory";

const getMobileNumber = ({
  isMultiPartnerJourney,
  selectedPartner,
  isCompanyMobileChanged,
  isSignatoryPrimaryMobileChanged,
  editedMobileNumber,
  mobileNo,
  isSignatory
}) => {
  if (isMultiPartnerJourney && selectedPartner && Object.keys(selectedPartner).length > 0) {
    if (isCompanyMobileChanged && isSignatory) {
      return selectedPartner.editedMobileNumber;
    } else if (isSignatoryPrimaryMobileChanged) {
      return (
        selectedPartner.contactDetails.editedPrimaryMobileNo ||
        selectedPartner.contactDetails.primaryMobileNo
      );
    } else {
      return selectedPartner.contactDetails.primaryMobileNo;
    }
  } else {
    if (isCompanyMobileChanged) {
      return editedMobileNumber;
    } else {
      return mobileNo;
    }
  }
};

export default function FormConfirmMobilePage() {
  useFormNavigation([false, false, formStepper]);
  useLayoutParams(true);
  useViewId();
  const { mobileNo, countryCode } = useSelector(getApplicantInfo);
  const signatoryInfo = useSelector(getSignatories);
  const isMultiPartnerJourney = useSelector(getIsMultiPartnerJourney);
  const selectedPartner = useSelector(getSelectedStakeholder);
  const isCompanyMobileChanged = useSelector(getIsMobileChanged);
  const isSignatoryPrimaryMobileChanged = useSelector(getIsSignatoryPrimaryMobileNoChanged);
  const isContactAndSignatoryDetailsChanged = useSelector(getsIsContactAndSignatoryDetailsChanged);
  const isSignatory = useSelector(checkIsSelectedStakeholderSignatory);

  const editedMobileNumber = signatoryInfo[0]?.editedMobileNumber;

  const mobileNumber = getMobileNumber({
    isMultiPartnerJourney,
    selectedPartner,
    isCompanyMobileChanged,
    isSignatoryPrimaryMobileChanged,
    editedMobileNumber,
    mobileNo,
    isSignatory
  });

  const suffixNumberStyle = {
    color: "#5E080B",
    fontWeight: 500,
    display: "inline-block"
  };

  const getTitle = () => {
    if (isMultiPartnerJourney) {
      return isCompanyMobileChanged ? "company" : "your";
    }
    return "your";
  };

  const title = `Let's verify ${getTitle()} mobile number`;

  const infoSpan = (
    <span>
      We sent a 6-digits One Time Password (OTP) to the number{" "}
      <span style={suffixNumberStyle}>{`+${countryCode} ${mobileNumber}`}</span>. Please enter it
      below.
    </span>
  );

  const changeText = "Change mobile number";

  return !isContactAndSignatoryDetailsChanged ? (
    <FormConfirm otpType={OtpChannel.Sms} title={title} info={infoSpan} changeText={changeText} />
  ) : (
    <FormConfirmCompanyAndSignatory
      otpType={OtpChannel.Sms}
      title={title}
      info={infoSpan}
      changeText={changeText}
    />
  );
}
